import { RightOutlined } from "@ant-design/icons"
import { Button, Flex } from "antd"
import { SERVICE_POLICY_URL } from "~/common/links"
import { Text } from "~/components/Text"
import { type PurchaseSelection } from "./professionalPlan"
import styles from "./index.css"

export type PurchaseHandler = (selection: PurchaseSelection) => void

export const freePointUnitPrice = 0.3
export const professionalPointUnitPrice = 0.25

export const PolicyFooter = () => {
  return (
    <Flex
      className={styles.policyFooter}
      align="center"
      justify="center"
      gap={4}
    >
      <Text
        size="s"
        type="secondary"
      >
        关于积点有效期、退款规则及更多详情，请查看
      </Text>
      <Button
        className={styles.policyLink}
        variant="link"
        color="primary"
        href={SERVICE_POLICY_URL}
        target="_blank"
      >
        服务权益与常见问题
        <RightOutlined />
      </Button>
    </Flex>
  )
}
